export const members = [
  {
    element: '.members_page',
    popover: {
      title: 'Team Members for Selected Client',
      description: 'This section allows you to manage members belonging to the selected client.',
      position: 'top',
    },
  },
  {
    element: '.tab-active-members',
    popover: {
      title: 'Active Members',
      description: 'View all currently active members for this client.',
      position: 'bottom',
    },
  },
  {
    element: '.tab-blocked-members',
    popover: {
      title: 'Blocked Members',
      description: 'This tab shows members who are blocked under the selected client.',
      position: 'bottom',
    },
  },
  {
    element: '.tab-onboarding-members',
    popover: {
      title: 'Onboarding Members',
      description: 'These members are in the onboarding process for the selected client.',
      position: 'bottom',
    },
  },
  {
    element: '.filter-by-role',
    popover: {
      title: 'Filter by Role',
      description: 'Filter members of this client based on their assigned roles (e.g., Admin, User).',
      position: 'left',
    },
  },
  {
    element: '.btn-create-member',
    popover: {
      title: 'Add New Member',
      description: 'Click here to create and assign a new member to this client.',
      position: 'left',
    },
  },
];
